import {FactsList} from '../../components/facts-list';

import {factsFromFactListFragment, type FactsListFragment} from './query';

type Props = {
	data: FactsListFragment;
	fullWidth?: boolean;
	insideToc?: boolean;
};

export const FactsListContainer = ({data, fullWidth, insideToc}: Props) => {
	return (
		<FactsList
			facts={factsFromFactListFragment(data)}
			options={{fullWidth, ...data?.contentBlockOptions}}
			insideToc={insideToc}
		/>
	);
};
